import './HackerAvatar.css';
import { useEffect, useRef, useState } from 'react';

const HACKER_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*()_+-=[]{}|;:,.<>?';
const COLORS = [
  '#00ff88', '#00ccff', '#ff00ff', '#ffff00', '#00ffff',
  '#ff6600', '#9933ff', '#00ff00', '#ff3366', '#66ccff'
];

function HackerAvatar({ src, alt }) {
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = useRef(null);
  const particlesRef = useRef([]);
  const frameRef = useRef(null);

  useEffect(() => {
    if (!isHovered || !containerRef.current) return;

    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();

    const createParticle = () => {
      const char = HACKER_CHARS[Math.floor(Math.random() * HACKER_CHARS.length)];
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      const size = 12 + Math.random() * 14;
      const x = Math.random() * containerRect.width;
      const y = containerRect.height + 20;
      const speed = 1 + Math.random() * 2.5;
      const rotation = Math.random() * 360;
      const rotationSpeed = (Math.random() - 0.5) * 4;
      const opacity = 0.6 + Math.random() * 0.4;
      const drift = (Math.random() - 0.5) * 1.5;

      return {
        char,
        color,
        size,
        x,
        y,
        speed,
        rotation,
        rotationSpeed,
        opacity,
        drift,
        id: Math.random()
      };
    };

    const animate = () => {
      if (Math.random() < 0.3) {
        particlesRef.current.push(createParticle());
      }

      particlesRef.current = particlesRef.current.filter(p => {
        p.y -= p.speed;
        p.x += p.drift;
        p.rotation += p.rotationSpeed;
        p.opacity -= 0.005;
        return p.opacity > 0 && p.y > -40;
      });

      renderParticles();
      frameRef.current = requestAnimationFrame(animate);
    };

    const renderParticles = () => {
      const existing = container.querySelectorAll('.hacker-char');
      existing.forEach(el => el.remove());

      particlesRef.current.forEach(p => {
        const span = document.createElement('span');
        span.className = 'hacker-char';
        span.textContent = p.char;
        span.style.left = p.x + 'px';
        span.style.top = p.y + 'px';
        span.style.fontSize = p.size + 'px';
        span.style.color = p.color;
        span.style.opacity = p.opacity;
        span.style.transform = `rotate(${p.rotation}deg)`;
        span.style.textShadow = `0 0 ${10 + Math.random() * 10}px ${p.color}`;
        container.appendChild(span);
      });
    };

    animate();

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
      particlesRef.current = [];
      const existing = container.querySelectorAll('.hacker-char');
      existing.forEach(el => el.remove());
    };
  }, [isHovered]);

  return (
    <div
      className="hacker-avatar-container"
      ref={containerRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={src} alt={alt} className="hacker-avatar" />
      <div className="hacker-avatar-glow" />
    </div>
  );
}

export default HackerAvatar;
